<div class="displaycard" fxLayout="column" *ngIf="entity" fxLayoutGap="20px">
  <!-- triangle -->
  <div class="triangle">
    <span [hidden]="entity.price_mode == 'PRICE_ON_REQUEST' && entity.price == '0,00'"
      >{{ entity.price | moneyInsertThousandSigns }}€&nbsp;</span
    >
    <span>{{ entity.price_mode | enumtranslate }}</span>
  </div>

  <author [profile]="author" [created_at]="entity.created_at"> </author>

  <div>
    <div class="title">{{ entity.advertisement_type == 'OFFER' ? 'bietet' : 'sucht' }}:</div>
    <div class="title break-word">{{ entity.title }}</div>
  </div>

  <div fxLayout="column" fxLayoutGap="15px" fxLayout.gt-md="row">
    <!-- images -->
    <div fxFlex.gt-md="70" fxLayout="column" fxLayoutGap="10px" class="swiper">
      <app-swiper [galleryImages]="entity.galleryImages"></app-swiper>
    </div>
    <!-- attributes -->
    <div fxFlex.gt-md="30" fxLayout="column" fxLayoutGap="10px" class="attributes">
      <!-- price -->
      <div fxLayout="row" class="attribute" *ngIf="entity.price_mode">
        <i class="fas fa-sack-dollar"></i>
        <span [hidden]="entity.price_mode == 'PRICE_ON_REQUEST' && entity.price == '0,00'">
          {{ entity.price | moneyInsertThousandSigns }}€&nbsp;
        </span>
        <span>{{ entity.price_mode | enumtranslate }}</span>
      </div>

      <!-- city zip -->
      <div fxLayout="row" class="attribute" *ngIf="entity.city || entity.zip">
        <i class="fas fa-map-marker-alt"></i>
        <span>{{ entity.zip }} {{ entity.city }}</span>
      </div>

      <!-- pick_up -->
      <div fxLayout="row" class="attribute" *ngIf="entity.delivery_pick_up">
        <i class="fas fa-person-dolly"></i>
        <span>Selbstabholung</span>
      </div>

      <!-- shipping -->
      <div fxLayout="row" class="attribute" *ngIf="entity.delivery_shipping">
        <i class="fas fa-person-dolly"></i>
        <span>Versand</span>
      </div>

      <!-- condition -->
      <div fxLayout="row" class="attribute" *ngIf="entity.condition">
        <i class="fas fa-star-half-alt"></i>
        <span>{{ entity.condition | enumtranslate }}</span>
      </div>

      <div fxLayout="row" class="attribute" *ngIf="entity.sale_type">
        <i class="fas fa-building"></i>
        <span>{{ entity.sale_type | enumtranslate }}</span>
      </div>

      <!-- telephone -->
      <div fxLayout="row" class="attribute" *ngIf="entity.contact_telephone">
        <i class="fas fa-phone"></i>
        <span>{{ entity.contact_telephone }}</span>
      </div>

      <!-- affiliate button -->
      <div fxLayout="row" class="attribute affiliatbtn" *ngIf="entity.affiliate_link" (click)="openAffiliateLink()">
        <i class="fas fa-arrow-right"></i>
        <span>{{ entity.affiliate_link_button_text ? entity.affiliate_link_button_text : 'Zum Produkt' }}</span>
      </div>
    </div>
  </div>

  <h3>Beschreibung</h3>
  <div [innerHTML]="entity.content" class="break-word"></div>
  <br />

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="10px">
    <share-buttons
      *ngIf="live"
      fxFlex.gt-md="50"
      [include]="mobileService.isMobile ? appConfig.shareconfig_mobile : appConfig.shareconfig_desktop"
      [show]="appConfig.sharebuttonsmax"
      [url]="entity.getOpgraphData().url"
      [autoSetMeta]="false"
      description=" "
    ></share-buttons>

    <div
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="end none"
      fxLayoutAlign.lt-lg="start center"
      fxFlex.gt-md="50"
      *ngIf="live"
    >
      <like-button [likeable]="entity" [live]="live"></like-button>
      <!-- <bookmark-button [bookmarked]="advert.bookmarks?.length>0" [entity]="advert"></bookmark-button> -->
    </div>
  </div>

  <div *ngIf="live && UserService.user && entity.frontend_user.id == UserService.user.id">
    <button fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" (click)="edit()">
      <i class="far fa-edit"></i>
      <div>Anzeige Bearbeiten</div>
    </button>
  </div>
</div>
